
<app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>
<!--<h3 mat-dialog-titleh3 style="margin-top: 3px; margin-bottom: 15px;text-decoration: underline;">
  Upload your files here !</h3>-->
  <div mat-dialog-content style="min-height:350px;">
    <!--<span class="sp"><b>Upload files for :</b> {{_data.fieldName}}</span><br><br>-->
    <div style="width: 100%; margin: auto;">
        <p style="width: 100%; margin: auto; font-size: 16px; text-align: center"><b>Valid file extensions: </b></p>
        <p *ngIf="_data.ScreenName !== 'TQApproverAttachment'" style="width: 100%; margin: auto; text-align: center">
            ( XLSX, PDF, DOC, XLS, DOCX, ZIP, MSG,
            EML )
        </p>
        <p *ngIf="_data.ScreenName === 'TQApproverAttachment'" style="width: 100%; margin: auto; text-align: center">
            ( PDF, PNG, JPEG, JPG, WORD, EXCEL, MAIL, ZIP FOLDER )
        </p>
    </div>
    <br>
    <div class="col-md-12">
        <input class="form-control" [disabled]="!((_data.IsFormEditable == true && IsApproved === false)|| _data.IsAttachmentEnable==true)" type="file"
               style="Padding:8px; background-color: #d6cdcd40;" (change)="UploadAttachment($event)"
               accept=".xlsx,.pdf,.doc,.xls,.docx,.zip.msg,.eml" />
    </div>
    <div>&nbsp;</div>

    <div class="col-md-12">
        <table>
            <tr *ngFor='let url of LocalAttachments' class="urlSet">
                <td style="padding: 5px;">
                    <div style="float: left;">
                        <a style="cursor:pointer;float: left; text-align: left; word-break: break-all;" (click)="DownloadFile(url.BlobId,url.File)">{{url.File}}</a>
                    </div>
                    <div style="float: right; " *ngIf="(_data.IsFormEditable == true && IsApproved == false)">
                        <button class="fa fa-trash" 
                        style="font-size:18px; color:red; cursor: pointer"
                           (click)="DeleteAttachment(url.FullName)">Delete</button>
                    </div>
                </td>
            </tr>
        </table>
    </div>

</div>
<div mat-dialog-actions>
    <div class="col-md-3 right" *ngIf="(_data.IsFormEditable == true && IsApproved === false)|| _data.IsAttachmentEnable==true">
        <button type="button" style="width: 100%" mat-stroked-button [mat-dialog-close]="{fieldName: _data.fieldName, Attachment: _data.Attachment, BlobId: _data.BlobId, LocalAttachments: LocalAttachments}" cdkFocusInitial>Ok</button>
    </div>
    <div class="col-md-3 right"
         *ngIf="_data.fieldName=='TermsConditionAttachment' && _data.ModuleName === 'PORequisition' && IsApproved === true">
        <button type="button" style="width: 100%" mat-stroked-button [mat-dialog-close]="_data" cdkFocusInitial>Submit</button>
    </div>
    <div class="col-md-3 left">
        <button type="button" style="width: 100%" mat-stroked-button (click)="onNoClick()">Cancel</button>
    </div>
</div>